/*  ========================================================================
    # Components - Product Card
    ========================================================================  */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Hooks
import useTranslation from '../hooks/useTranslation';
import useURLParams from '../hooks/useURLParams';

const ProductCard = ({ hideImage, upsellingContent, product, selectItemObject, upsellingBadge }) => {
  const __ = useTranslation();
  const [productUrl, setProductUrl] = useState(product.link);
  const { params, setParams } = useURLParams();

  // console.log(selectItemObject);

  const handleProductClick = e => {
    e.preventDefault();

    if (window && window.dataLayer) {
      window.dataLayer.push(selectItemObject);
    }

    // Redirect to the product URL
    window.location.href = productUrl;
  };

  useEffect(() => {
    if (params.get('wt')) {
      setProductUrl(prevUrl => {
        const url = new URL(prevUrl);
        url.searchParams.set('wt', params.get('wt'));
        return url.toString();
      });
    }
  }, [params]);

  return (
    <div className={`c-product-card ${upsellingBadge ? 'c-product-card--with-badge' : ''}`}>
      {upsellingBadge && (
        <div className='c-product-card__upselling-badge'>
          <span>{upsellingBadge}</span>
        </div>
      )}
      <div className='c-product-card__wrapper'>
        {!hideImage && product.image && (
          <div className='c-product-card__image'>
            <a
              href={productUrl}
              target='_blank'
              rel='noreferrer'
              tabIndex={-1}
              aria-hidden='true'
            >
              <figure>
                <picture>
                  <img srcSet={`${product.image.sizes['medium']}, ${product.image.sizes['medium_large']} 2x`} src={product.image.sizes['medium']} alt={product.image['alt']} />
                </picture>
              </figure>
            </a>
          </div>
        )}
        <div className='c-product-card__content'>
          <div className='c-product-card__title'>
            {product.subtitle && (
              <span className='u-subheadline' aria-hidden dangerouslySetInnerHTML={{ __html: product.subtitle }}></span>
            )}
            <h3 className='h4' dangerouslySetInnerHTML={{ __html: product.title }}></h3>
          </div>
          <div className='c-product-card__price'>
            {product.crossedOutPrice && (
              <span className='c-product-card__price-crossed-out'>
                {`${product.crossedOutPrice} €`}
              </span>
            )}
            <p className='h2'>
              {product.showFromLabel ? <span className='h4'>ab </span> : ''}
              {`${product.price} €`}
            </p>
            {product.priceInfo && (
              <span className='u-text-advisory'>{product.priceInfo}</span>
            )}
          </div>
          <a
            href={productUrl}
            target='_blank'
            title={`Jetzt ${product.title} bestellen`}
            className='c-button'
            rel='noreferrer'
            onClick={e => handleProductClick(e)}
          >
            {product.ctaOverride ? product.ctaOverride : __('button-order-now')}
          </a>
        </div>
        {product.services && product.services.length > 0 && (
          <div className='c-product-card__services'>
            <ul className='u-list-checkmark'>
              {product.services.map((entry, index) => (
                <li key={index}>
                  <span>{entry.service}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        {product.priceInfoDescription && (
          <p className='c-product-card__price-info u-text-advisory'>
            {product.priceInfoDescription}
          </p>
        )}

        {upsellingContent && (
          <div className='c-product-card__upselling wysiwyg-block' dangerouslySetInnerHTML={{ __html: upsellingContent }}></div>
        )}
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  hideImage: PropTypes.bool,
  upsellingContent: PropTypes.string,
  product: PropTypes.array,
  selectItemObject: PropTypes.array,
  upsellingBadge: PropTypes.string
};

export default ProductCard;
